import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!environment.production) {
        console.error('[HTTP Error]', {
          status: error.status,
          statusText: error.statusText,
          url: error.url,
          message: error.message,
        });
      }

      if (error.status === 401) {
        authService.handleUnauthorizedResponse();
      }
      // Note: 403 errors are handled by individual components/dialogs
      // (may indicate validation failure from API or actual forbidden access)
      // 5xx — pass through; global error handling can catch these
      return throwError(() => error);
    }),
  );
};
